import React from "react";
import USDCorrelations from "./USDCorrelations";
import "./MarketInsights.scss";
import MarketVolume from "./MarketVolume";
import SectorPerformance from "./SectorPerformance";
import StyleSectorPerformance from "./StyleSectorPerformance";
import RatesAndSpreads from "./RatesAndSpreads";
import { API, graphqlOperation } from "aws-amplify";

export default function MarketInsights(props) {
  const [handler, setHandler] = React.useState("");
  const [featureFlag, setFeatureFlag] = React.useState(false);

  React.useEffect(() => {
    const handling = (e) => setHandler({ matches: e.matches });
    window
      .matchMedia("(max-width: 480px)")
      .addEventListener("change", handling);
  }, [handler]);

  React.useEffect(() => {
    const async = async () => {
      const users = await API.graphql(
        graphqlOperation(
          `{
            users {
              user_type
            }
          }`,
        ),
      );
      if (users?.data?.users[0]?.user_type === "admin") {
        setFeatureFlag(true);
      }
    };
    async();
  }, []);

  return (
    <div>
      <div className="dashboard-content">
        <div className="market-insights">
          <div className="column">
            <SectorPerformance reload={props.reload} />
            {featureFlag && <StyleSectorPerformance reload={props.reload} />}
          </div>
          <div className="column">
            <MarketVolume reload={props.reload} />
            <USDCorrelations reload={props.reload} />
            <RatesAndSpreads reload={props.reload} />
          </div>
        </div>
      </div>
    </div>
  );
}
